import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {searchTargetingWithSearchCriteria} from "../../services/facebook-targeting-data.service";
import TargetingFilters from "./targeting-filters";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import AddEditTargeting from "./add-edit-targeting";
import {TARGETING_FIELDS_LIST} from "../../constants/targeting.constant";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import GoToLink from "../../../common/ui/go-to-link";


const defaultFilterCriteria: any = {};

const TargetingList = () => {
    const [targetingList, setTargetingList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getTargetingList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const targetingListResult = await searchTargetingWithSearchCriteria(searchCriteriaList);

        setTargetingList(targetingListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getTargetingList();
    }, [filterCriteria]);

    const refreshTargetingList = async () => {
        await getTargetingList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Targeting
                    </div>

                    <TargetingFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">
                        <AddEditTargeting
                            isAddTargeting={true}
                            refreshTargetingList={refreshTargetingList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={targetingList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Targeting'}/>

                    {targetingList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {TARGETING_FIELDS_LIST?.map((targetingField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${targetingField?.cssClass}`}>{targetingField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {targetingList?.map((targeting, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {TARGETING_FIELDS_LIST?.map((targetingField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${targetingField?.cssClass}`}>
                                                {targetingField?.optionsMap &&
                                                    <>{targetingField?.optionsMap[targeting[targetingField?.attribute]]?.name}</>
                                                }

                                                {!targetingField?.optionsMap &&
                                                    <>
                                                        {targeting[targetingField?.attribute]}

                                                        {targetingField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {targeting[targetingField?.secondaryAttribute]}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-40">
                                        <div className="flex justify-center">
                                            <AddEditTargeting
                                                isEditTargeting={true}
                                                selectedTargeting={targeting}
                                                refreshTargetingList={refreshTargetingList}/>

                                            <GoToLink
                                                cssClass="ml-2 button-green px-2 py-1"
                                                label="Design"
                                                url={`targetings/${targeting?.id}/design`}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default TargetingList
